import React from 'react'

const styles = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1c2419',
    minWidth: 140
  },
  inputWrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center'
  },
  input: {
    fontFamily: "'Geist Mono', ui-monospace, 'JetBrains Mono', Menlo, monospace",
    fontSize: 13,
    fontWeight: 600,
    width: 80,
    textAlign: 'right',
    background: '#f6f1e3',
    border: '1px solid #cec3a5',
    borderRadius: 999,
    padding: '4px 10px',
    outline: 'none',
    color: '#1c2419',
    boxSizing: 'border-box'
  },
  unit: {
    fontSize: 12,
    color: '#6f7a6b'
  },
  requiredBang: {
    position: 'absolute',
    left: 8,
    color: '#a9341d',
    fontWeight: 700,
    fontSize: 13,
    lineHeight: 1,
    pointerEvents: 'none'
  },
  requiredChip: {
    background: '#f7dccf',
    color: '#a9341d',
    fontSize: 10,
    padding: '1px 6px',
    borderRadius: 999,
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  }
}

const PillNumber = ({ value, onChange, unit, required, label }) => {
  const [focused, setFocused] = React.useState(false)

  const isEmpty = value === '' || value === null || value === undefined
  const showError = required && isEmpty

  const inputStyle = {
    ...styles.input,
    ...(focused
      ? {
          background: '#fff',
          borderColor: '#1f5e3a',
          boxShadow: '0 0 0 3px rgba(31,94,58,.18)'
        }
      : {}),
    ...(showError
      ? {
          borderColor: '#a9341d',
          paddingLeft: 22
        }
      : {})
  }

  return (
    <div style={styles.container}>
      {label && <span style={styles.label}>{label}</span>}
      <span style={styles.inputWrapper}>
        {showError && <span style={styles.requiredBang}>!</span>}
        <input
          type="number"
          style={inputStyle}
          value={value ?? ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </span>
      {unit && <span style={styles.unit}>{unit}</span>}
      {showError && <span style={styles.requiredChip}>Required</span>}
    </div>
  )
}

export default PillNumber
